import React from 'react';
import Hero from '../components/Hero';
import Divider from '../components/Divider';
import Foodmenu from '../components/Foodmenu';
import Gallery from './Gallery';
import BookTableForm from '../components/Bookform';
import MenuSection from '../components/MenuSection';
import OurStory from '../components/OurStory';
import MenuHero from '../components/MenuHero';

const Home = () => {
  return (
    <div>
      <Hero />
    
      <MenuSection/>
      <Divider/>
      <div>
      <OurStory/>
            <div>
            <MenuHero/>
          <Foodmenu/>
          <Divider/>
          <div>
          <Gallery/>
          <Divider/>
          <div>
         
          <BookTableForm/>
          <Divider/>
          </div>
          </div>
         </div>
        </div>
        
      </div>

    
  );
};

export default Home;
